<template>
  <div id="RatesView" class="rates-view">
    <Header></Header>
    <b-container fluid>
      <b-row>
        <CompetitorLeftNav></CompetitorLeftNav>
        <b-col>
          <b-row class="justify-content-end mt-5 mb-3">
            <b-col sm="2">
              <b-form-group id="select-origination" label="Select origination" labelFor="select-origination-select" class="select-origination-label">
                <multiselect id="select-origination-select" v-model="origination" :options="originationCountries" :custom-label="customLabel" track-by="id" :show-labels="false" :allow-empty="false" :disabled="isLoading"></multiselect>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group id="select-destination" label="Select destination" labelFor="select-destination-select" class="select-destination-label">
                <multiselect id="select-destination-select" v-model="destination" :options="countries" label="name" track-by="isoAlpha2" :show-labels="false" :allow-empty="false" :disabled="isLoading"></multiselect>
              </b-form-group>
            </b-col>
             <b-col sm="2" class="bottom">
              <b-button variant="default" class="icon-container" @click.prevent="search" :disabled="isLoading">
                <i class="material-icons" :class="{ rotating: isSearching }">search</i>
                <span>Search</span>
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="pl-sm-5">
              <b-table striped
                :items="callingCorridors"
                :fields="fields"
                :filter="tableFilter"
                @sort-changed="sortingChanged"
                :sort-compare="compareRows"
                :sort-direction="sortDirection"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc">
                <template slot="provider" slot-scope="data">
                  <h6>
                    {{data.item.provider.name}}
                  </h6>
                </template>
                <template slot="lastProcessed" slot-scope="data">
                  {{data.item.lastProcessed | formatDate}}
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import CompetitorLeftNav from '@/components/layout/CompetitorLeftNav'
import Header from '@/components/layout/Header'
import { mapActions, mapGetters } from 'vuex'
import { sortByDate, sortByProviderName, sortRate } from '@/util/sorting'
export default {
  name: 'Rates',
  components: {
    CompetitorLeftNav,
    Header
  },
  created () {
    this.clearCallingCorridors()
    this.fetchOriginationCountries().then(() => {
      this.fetchCountries().then(() => {

      })
    })
  },
  methods: {
    ...mapActions({
      'fetchOriginationCountries': 'competitor/fetchOriginationCountries',
      'fetchCountries': 'competitor/fetchCountries',
      'searchCallingCorridors': 'competitor/searchCallingCorridors',
      'clearCallingCorridors': 'competitor/clearCallingCorridors'
    }),
    compareRows (a, b) {
      if (this.sortBy === 'lastProcessed') {
        return sortByDate(this.sortDesc, a.lastProcessed, b.lastProcessed)
      } else if (this.sortBy === 'provider') {
        return sortByProviderName(this.sortDesc, a, b)
      } else if (this.sortBy === 'mobile') {
        return sortRate(this.sortDesc, a.mobile, b.mobile)
      } else if (this.sortBy === 'landline') {
        return sortRate(this.sortDesc, a.landline, b.landline)
      } else if (this.sortBy === 'connectionFee') {
        return sortRate(this.sortDesc, a.connectionFee, b.connectionFee)
      } else if (this.sortBy === 'mobileCost5Min') {
        return sortRate(this.sortDesc, a.mobileCost5Min, b.mobileCost5Min)
      } else if (this.sortBy === 'landlineCost5Min') {
        return sortRate(this.sortDesc, a.landlineCost5Min, b.landlineCost5Min)
      } else if (this.sortBy === 'rounding') {
        return sortRate(this.sortDesc, a.rounding, b.rounding)
      } else if (this.sortBy === 'minuteSurcharge') {
        return sortRate(this.sortDesc, a.minuteSurcharge, b.minuteSurcharge)
      }
    },
    sortingChanged (ctx) {
      this.sortBy = ctx.sortBy
      this.sortDesc = ctx.sortDesc
    },
    search () {
      if (this.destination.isoAlpha2 !== undefined) {
        this.isSearching = true
        this.searchCallingCorridors({origination: this.origination.isoAlpha2, destination: this.destination.isoAlpha2}).then(() => {
          this.isSearching = false
        })
      } else {
        this.$toastr.e('Select a destination')
      }
    },
    customLabel ({ isoAlpha2, currencyCode }) {
      return `${isoAlpha2} – ${currencyCode}`
    }
  },
  computed: {
    ...mapGetters({
      'originationCountries': 'competitor/originationCountries',
      'countries': 'competitor/countries',
      'callingCorridors': 'competitor/callingCorridors',
      'isLoading': 'loader/isLoading'
    })
  },
  data () {
    return {
      isSearching: false,
      origination: { id: 1, isoAlpha2: 'US', currencyCode: 'USD' },
      destination: { },
      sortBy: 'mobileCost5Min',
      sortDesc: false,
      sortDirection: 'desc',
      tableFilter: null,
      fields: [
        { key: 'provider', label: 'Provider', sortable: true },
        { key: 'mobile', label: 'Mobile', sortable: true },
        { key: 'landline', label: 'Landline', sortable: true },
        { key: 'connectionFee', label: 'Connection fee', sortable: true },
        { key: 'rounding', label: 'Min. rounding', sortable: true },
        { key: 'minuteSurcharge', label: 'Min. surcharge', sortable: true },
        { key: 'mobileCost5Min', label: 'Mobile 5 min', sortable: true },
        { key: 'landlineCost5Min', label: 'Landline 5 min', sortable: true },
        { key: 'lastProcessed', label: 'Last updated', sortable: true }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.bottom{
  margin-bottom: 18px;
  margin-top: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/competitor/Rates.vue